import LinkView from '~/features/chatbot/components/linkView'
import Simple from '~/features/chatbot/components/simple'
import { EChatbotTheme } from '~/features/settings/models'
import { store } from '~/store'

function ChatBotPage() {
  const chatbotTheme = store((state) => state.chatbot.layout.selection.theme)

  switch (chatbotTheme) {
    case EChatbotTheme.linkView:
      return <LinkView />
    case EChatbotTheme.simple:
      return <Simple />
    default:
      return <LinkView />
  }
}

export default ChatBotPage
